module.exports = __webpack_public_path__ + "static/media/siddharth-bannerghatta-zoo-trip-banner.37ba76a9.jpg";